import { styled } from 'styled-components';

import PasswordRevealSVG from '../assets/password-reveal-icon.svg?react';

export const StyledPasswordRevealIcon = styled(PasswordRevealSVG)`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
